module.exports = __webpack_public_path__ + "static/media/poi_ambulance_multi.51f40e9b.svg";